// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__VCeS9","rotation":"Loader_rotation__Aftp3","small":"Loader_small__xuvGn","white":"Loader_white__vqWow"};